export const PATHS = {
	LOGIN_PAGE: `/login`,
	AUTH_CODE_PAGE: `/auth/code`,
	AUTH_PAGE: `/auth`,
	HOME_PAGE: `/`,
	SIGN_IN_PAGE: `/sign-in`,
	INACTIVITY_PAGE: `/inactivity`,
	SHOPS_PAGE: `/shops`,
	GOODS_PAGE: `/shops/:shopId/goods`,
	CLASSIFICATIONS_PAGE: `/classifications`,
};
